import { FetchResult, gql } from 'apollo-boost';
import { IUserPlan } from '../../../models/user-plan';
import { IUser } from '../../../models/user';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation UserUpdatePlan($planUid: String!){
        user_update_plan (planUid: $planUid) {
            success,
            payment_url,
            user {
                uid,
                userPlan: user_plan {
                    uid
                },
            },
        }
    }
`;

export interface IResultUpdateUserPlan {
    success: boolean;
    payment_url: string;
    user: IUser;
}

export async function updateUserPlan(planUid: string): Promise<string> {
    const result: FetchResult<{ user_update_plan: IResultUpdateUserPlan }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { planUid },
        errorPolicy: 'all',
    });

    if(!result.data || (result.errors && result.errors.length)) {
        throw new MultiError(result.errors || ['Unknown error']);
    }
    console.log("result data: ", result.data.user_update_plan);

    return result.data.user_update_plan.payment_url;
}
